<!--
 * @description: 模块标题
 * @Author: wxy
 * @Date: 2020-02-11 14:17:37
 -->
<template>
  <h3>
    <slot></slot>
  </h3>
</template>

<script>
export default {
  name: ''
}
</script>

<style lang='scss' scoped>
h3 {
  font-weight: normal;
  font-size: 22px;
  color: #333;
  text-align: center;
  line-height: 90px;
}
</style>
